export default __webpack_public_path__ + "static/media/ornn.29f50212.png";